/**
 * @generated SignedSource<<ce4e2a46556441832aba6413a4c807f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OccurrenceMembersStatus = "attended" | "not_attended" | "not_rsvpd" | "not_watched_recording" | "rsvpd" | "watched_recording" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipsOrderBy = "bio" | "joined_on" | "member_name" | "members_list" | "recently_active" | "%future added value";
export type OrganizationMembershipsProfileFieldStatus = "not_responded" | "responded" | "%future added value";
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
export type CreateOrganizationMembershipCSVDataInput = {
  direction?: OrderDirection | null;
  isSlackConnected?: boolean | null;
  membershipPlanIds?: ReadonlyArray<string> | null;
  occurrences?: ReadonlyArray<OrganizationMembershipsOccurrenceFilter> | null;
  orderBy?: OrganizationMembershipsOrderBy | null;
  organizationId?: string | null;
  productIds?: ReadonlyArray<string> | null;
  profileFields?: ReadonlyArray<OrganizationMembershipsProfileFieldFilter> | null;
  roles?: ReadonlyArray<OrganizationRole> | null;
  search?: string | null;
};
export type OrganizationMembershipsProfileFieldFilter = {
  id: string;
  optionId?: string | null;
  status?: OrganizationMembershipsProfileFieldStatus | null;
};
export type OrganizationMembershipsOccurrenceFilter = {
  id: string;
  status?: OccurrenceMembersStatus | null;
};
export type CommunityPeopleReportTableMutation$variables = {
  input: CreateOrganizationMembershipCSVDataInput;
};
export type CommunityPeopleReportTableMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type CommunityPeopleReportTableMutation = {
  response: CommunityPeopleReportTableMutation$data;
  variables: CommunityPeopleReportTableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrganizationMembershipCSVDataResponse",
    "kind": "LinkedField",
    "name": "createOrganizationMembershipCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityPeopleReportTableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunityPeopleReportTableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7949e8a41cadb0ed7733f952d85e0aa2",
    "id": null,
    "metadata": {},
    "name": "CommunityPeopleReportTableMutation",
    "operationKind": "mutation",
    "text": "mutation CommunityPeopleReportTableMutation(\n  $input: CreateOrganizationMembershipCSVDataInput!\n) {\n  response: createOrganizationMembershipCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83a4ae7790f0879ad12f048603bce280";

export default node;
